import { IStore, StoreContext } from "store/store-context";
import { IBulkBatch } from "store/types";
import { useContextSelector } from "use-context-selector";

export const useBulkBatchesSelector = (): Record<string, IBulkBatch> =>
  useContextSelector(StoreContext, (store: IStore) => store.bulkUpload.batches);
